import React, {Component} from 'react';
import qs from 'qs';
import '../styles/views.css';
import { addViews, takeViews } from '../services/viewsService';
import {
  Box,
  Paper,
  Stack,
  Typography,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  CircularProgress,
  Snackbar,
  Alert
} from '@mui/material';

class Views extends Component {
  constructor(props) {
    super(props);
    this.state = {
      view: '',
      month: '',
      year: '',
      submitting: false,
      snackbar: { open: false, severity: 'success', message: '' }
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.querieswiews = this.querieswiews.bind(this);
    this.closeSnackbar = this.closeSnackbar.bind(this);
  }

  closeSnackbar() {
    this.setState({ snackbar: { ...this.state.snackbar, open: false } });
  }

  async querieswiews(event) {
    event.preventDefault();

    const { view, month, year } = this.state;
    if (!view || !month || !year) {
      this.setState({
        snackbar: { open: true, severity: 'warning', message: 'Veuillez renseigner View, Month et Year.' }
      });
      return;
    }

    this.setState({ submitting: true });

    const website = { view, month, year };
    const parsed = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });

    const isAdd = parsed.add && parsed.add !== 'undefined' && parsed.add.length > 0;

    try {
      const body = isAdd
        ? await addViews(parsed.website_id, website.year, website.view, website.month, website)
        : await takeViews(parsed.website_id, website.year, website.view, website.month, website);

      if (body?.err) {
        this.setState({
          snackbar: { open: true, severity: 'error', message: body.err || 'Erreur lors de la mise à jour.' }
        });
      } else {
        this.setState({
          snackbar: { open: true, severity: 'success', message: 'Mise à jour effectuée.' }
        });
        // Retour à la liste après un court délai pour laisser le snackbar s’afficher
        setTimeout(() => {
          this.props.history.push(`/super-admin/website`);
        }, 600);
      }
    } catch (e) {
      this.setState({
        snackbar: { open: true, severity: 'error', message: 'Erreur réseau, veuillez réessayer.' }
      });
    } finally {
      this.setState({ submitting: false });
    }
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({ [name]: value });
  }

  render() {
    const { view, month, year, submitting, snackbar } = this.state;

    return (
      <Box sx={{ p: 2 }}>
        <Paper variant="outlined" sx={{ p: 3, maxWidth: 600 }}>
          <Stack spacing={2}>
            <Typography variant="h6">Update Views</Typography>

            <Box component="form" onSubmit={this.querieswiews}>
              <Stack spacing={2}>
                <TextField
                  label="View"
                  name="view"
                  type="number"
                  value={view}
                  onChange={this.handleInputChange}
                  fullWidth
                  required
                  inputProps={{ min: 0 }}
                />

                <FormControl fullWidth required>
                  <InputLabel id="month-label">Month</InputLabel>
                  <Select
                    labelId="month-label"
                    name="month"
                    label="Month"
                    value={month}
                    onChange={this.handleInputChange}
                  >
                    <MenuItem value=""><em>Choose Month</em></MenuItem>
                    {Array.from({ length: 12 }, (_, i) => {
                      const v = String(i + 1);
                      const label = String(i + 1).padStart(2, '0');
                      return <MenuItem key={v} value={v}>{label}</MenuItem>;
                    })}
                  </Select>
                </FormControl>

                <FormControl fullWidth required>
                  <InputLabel id="year-label">Year</InputLabel>
                  <Select
                    labelId="year-label"
                    name="year"
                    label="Year"
                    value={year}
                    onChange={this.handleInputChange}
                  >
                    <MenuItem value=""><em>Choose Year</em></MenuItem>
                    {['2015','2016','2017','2018','2019','2020','2021','2022','2023','2024','2025','2026', '2027', '2028', '2029', '2030'].map(y => (
                      <MenuItem key={y} value={y}>{y}</MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Button
                    type="submit"
                    variant="contained"
                    disabled={submitting}
                    startIcon={submitting ? <CircularProgress size={18} /> : null}
                  >
                    {submitting ? 'Saving...' : 'Save'}
                  </Button>
                </Box>
              </Stack>
            </Box>
          </Stack>
        </Paper>

        <Snackbar
          open={snackbar.open}
          autoHideDuration={3000}
          onClose={this.closeSnackbar}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
          <Alert onClose={this.closeSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Box>
    );
  }
}

export default Views;